import React from 'react';
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import ErrorList from '../ErrorList';

type HostnameOptionProps = {
    hostname?: string;
    description?: React.ReactNode;
    onChange: (name: string) => unknown;
    errors?: string[];
    showAdvanced?: boolean;
};

export default class HostnameOption extends React.Component<HostnameOptionProps> {
    render() {
        const { hostname, onChange, errors, description, showAdvanced } = this.props;
        const defaultDescription = (
            <p>
                Please enter the DNS hostname of your server, such as vps01.yourcompany.com. It does not matter if you
                do not yet own this domain name or have not yet setup a DNS entry for it.
            </p>
        );
        return (
            <>
                {showAdvanced && (description ?? defaultDescription)}
                <FormGroup>
                    <Label for="serverSettingHostname">Hostname</Label>
                    <Input
                        id="serverSettingHostname"
                        value={hostname ?? ''}
                        placeholder="server.example.com"
                        onChange={(e) => onChange(e.target.value)}
                        invalid={errors && errors.length > 0}
                    />
                    <FormFeedback>
                        <ErrorList errors={errors} />
                    </FormFeedback>
                </FormGroup>
            </>
        );
    }
}
